import {
  m6 as objectMeta,
  ga as VOID,
  o6 as setMetadataFor,
  p5 as classMeta,
  e1 as ArrayList,
  r9 as RuntimeException,
  j1 as LinkedHashMap,
  z1 as checkIndexOverflow,
  c4 as toList,
} from './kotlin-kotlin-stdlib.mjs';
import {
  u as AglEditorJsAbstract,
  d as Companion_getInstance,
  y as AglTokenizer,
  x as AglTokenizerByWorker,
} from './net.akehurst.language.editor-agl-editor-common.mjs';
import {
  b as removeClass,
  a as addClass,
} from './kotlin_org_jetbrains_kotlin_kotlin_dom_api_compat.mjs';
//region block: imports
//endregion
//region block: pre-declaration
class BuildConfig_0 {
  constructor() {
    BuildConfig_instance = this;
    this.version = '1.9.20-Beta';
    this.buildStamp = '2023-09-29T11:11:46.82712Z[UTC]';
    this.buildDate = '2023-Sept-29';
    this.buildTime = '11:11:46 UTC';
    this.versionEditorCodeMirror = '6.0.1';
  }
  nt() {
    return this.version;
  }
  ot() {
    return this.buildStamp;
  }
  pt() {
    return this.buildDate;
  }
  qt() {
    return this.buildTime;
  }
  k4x() {
    return this.versionEditorCodeMirror;
  }
}
class AglErrorAnnotation {
  constructor(line, column, text, type, raw) {
    this.line = line;
    this.column = column;
    this.text = text;
    this.type = type;
    this.raw = raw;
    this.row = this.line - 1 | 0;
  }
  v2j() {
    return this.line;
  }
  u2j() {
    return this.column;
  }
  u1p() {
    return this.text;
  }
  em() {
    return this.type;
  }
  s4s() {
    return this.raw;
  }
  t4s() {
    return this.row;
  }
}
class AglEditorCodeMirror extends AglEditorJsAbstract {
  constructor(containerElement, cmEditor, languageId, editorId, logFunction, worker) {
    super(languageId, editorId, logFunction, worker);
    this.r4x_1 = containerElement;
    this.s4x_1 = cmEditor;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$0 = ArrayList.i4();
    tmp.t4x_1 = tmp$ret$0;
    var tmp_0 = this;
    var tmp$ret$1;
    // Inline function 'kotlin.collections.mutableListOf' call
    tmp$ret$1 = ArrayList.i4();
    tmp_0.u4x_1 = tmp$ret$1;
  }
  x4c() {
    return this.s4x_1;
  }
  k4n() {
    return 'none';
  }
  g4d(value) {
    try {
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to set text in editor');
      } else {
        throw $p;
      }
    }
  }
  u1p() {
    try {
      return '';
    } catch ($p) {
      if ($p instanceof Error) {
        var t = $p;
        throw RuntimeException.u6('Failed to get text from editor');
      } else {
        throw $p;
      }
    }
  }
  destroy() {
  }
  configureSyntaxAnalyser(configuration) {
  }
  updateLanguage(oldId) {
    if (!(null == oldId)) {
      var oldAglStyleClass = Companion_getInstance().languageIdToStyleClass(this.agl.styleHandler.cssClassPrefixStart, oldId);
      removeClass(this.r4x_1, [oldAglStyleClass]);
    }
    addClass(this.r4x_1, [this.agl.styleHandler.aglStyleClass]);
  }
  updateStyle() {
  }
  resetTokenization() {
  }
  processSentence() {
    this.clearErrorMarkers();
  }
  clearErrorMarkers() {
  }
  createIssueMarkers(issues) {
  }
}
class AglTokenizerByWorkerCodeMirror {
  constructor(agl) {
    this.aglTokenizer = new AglTokenizer(agl);
    this.v4x_1 = false;
    var tmp = this;
    var tmp$ret$0;
    // Inline function 'kotlin.collections.mutableMapOf' call
    tmp$ret$0 = LinkedHashMap.n8();
    tmp.w4x_1 = tmp$ret$0;
  }
  q4t() {
    return this.aglTokenizer;
  }
  s4n(_set____db54di) {
    this.v4x_1 = _set____db54di;
  }
  t4n() {
    return this.v4x_1;
  }
  u4n() {
    return this.w4x_1;
  }
  reset() {
    this.v4x_1 = false;
    this.w4x_1.n1();
  }
  receiveTokens(tokens) {
    if (this.v4x_1) {
      // Inline function 'kotlin.collections.forEachIndexed' call
      var index = 0;
      var tmp0_iterator = tokens.u();
      while (tmp0_iterator.h1()) {
        var item = tmp0_iterator.j1();
        // Inline function 'net.akehurst.language.editor.browser.codemirror.AglTokenizerByWorkerCodeMirror.receiveTokens.<anonymous>' call
        var tmp1 = index;
        index = tmp1 + 1 | 0;
        var tmp0_anonymous = checkIndexOverflow(tmp1);
        var tmp$ret$0;
        // Inline function 'kotlin.collections.isNotEmpty' call
        tmp$ret$0 = !item.y();
        if (tmp$ret$0) {
          // Inline function 'kotlin.collections.set' call
          var tmp0_set = this.w4x_1;
          var tmp1_set = toList(item);
          tmp0_set.m3(tmp0_anonymous, tmp1_set);
        } else {
        }
      }
    }
  }
  get acceptingTokens() {
    return this.t4n();
  }
  set acceptingTokens(value) {
    this.s4n(value);
  }
  get tokensByLine() {
    return this.u4n();
  }
}
//endregion
var BuildConfig_instance;
function BuildConfig_getInstance() {
  if (BuildConfig_instance === VOID)
    new BuildConfig_0();
  return BuildConfig_instance;
}
function attachToCodeMirror(_this__u8e3s4, containerElement, cmEditor, languageId, editorId, logFunction, worker) {
  return new AglEditorCodeMirror(containerElement, cmEditor, languageId, editorId, logFunction, worker);
}
//region block: post-declaration
setMetadataFor(BuildConfig_0, 'BuildConfig', objectMeta);
setMetadataFor(AglErrorAnnotation, 'AglErrorAnnotation', classMeta);
setMetadataFor(AglEditorCodeMirror, 'AglEditorCodeMirror', classMeta);
setMetadataFor(AglTokenizerByWorkerCodeMirror, 'AglTokenizerByWorkerCodeMirror', classMeta, VOID, [AglTokenizerByWorker]);
//endregion
//region block: exports
var BuildConfig = {getInstance: BuildConfig_getInstance};
export {
  BuildConfig,
  AglErrorAnnotation,
  attachToCodeMirror,
  AglTokenizerByWorkerCodeMirror,
};
export {
  attachToCodeMirror as a,
};
//endregion

//# sourceMappingURL=net.akehurst.language.editor-agl-editor-browser-codemirror.mjs.map
